import { render, staticRenderFns } from "./TheLayoutWrap.vue?vue&type=template&id=4a0235ff&scoped=true&"
import script from "./TheLayoutWrap.vue?vue&type=script&lang=js&"
export * from "./TheLayoutWrap.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutWrap.vue?vue&type=style&index=0&id=4a0235ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0235ff",
  null
  
)

export default component.exports